/* eslint-disable react/prop-types */
import {
  CCard,
  CCardBody,
  CCardImage,
  CCardSubtitle,
  CCardText,
  CCardTitle,
  CCol,
  CRow
} from '@coreui/react';
import Link from 'next/link';
import colors from 'utils/colors';
import { Pagination } from '../../../parts/blogs/index';

function Items({ data, language, currentPage, pageSize }) {
  return (
    <>
      <div className="content mb-5">
        <div className="col-our-office-location">
          <div className="container">
            <CRow>
              {data?.length > 0 ? (
                data?.map((item, index) => (
                  <CCol key={index} md={4}>
                    <Link
                      href={
                        language === 'EN'
                          ? item.en_slug
                            ? '/blogs/detail/' + item.en_slug
                            : '#'
                          : item.id_slug
                          ? '/blogs/detail/' + item.id_slug
                          : '#'
                      }
                      locale={language === 'ID' ? 'id' : 'en'}
                    >
                      <a>
                        <CCard
                          className="col-contents-box-blogs"
                          style={{
                            // width: '350px',
                            // boxShadow: `0px 0px 15px gray`,
                            marginBottom: '50px',
                            borderTopLeftRadius: '12px !important',
                            borderTopRightRadius: '12px !important'
                            // cursor: "pointer",
                          }}
                        >
                          <CCardImage
                            className="image-blogs"
                            style={{
                              borderTopLeftRadius: '12px !important',
                              borderTopRightRadius: '12px !important'
                            }}
                            height="300"
                            orientation="top"
                            src={
                              language === 'EN'
                                ? item.en_featured_img
                                : item.id_featured_img
                            }
                          />
                          <CCardBody className="card-body card-body-blogs">
                            <CCardSubtitle className="mb-2 text-medium-emphasis">
                              Posted On {item.publishedAt || '-'}
                            </CCardSubtitle>
                            <CCardTitle
                              dangerouslySetInnerHTML={{
                                __html:
                                  language === 'EN'
                                    ? item.en_title
                                    : item.id_title
                              }}
                            ></CCardTitle>
                            <CCardText
                              dangerouslySetInnerHTML={{
                                __html:
                                  language === 'EN'
                                    ? item.en_meta_content
                                    : item.id_meta_content
                              }}
                            ></CCardText>
                          </CCardBody>
                        </CCard>
                      </a>
                    </Link>
                  </CCol>
                ))
              ) : (
                <div className="text-center">
                  <p
                    className="fw-semibold fs-4"
                    style={{ color: colors.blue1, letterSpacing: '0.1px' }}
                  >
                    There are no post yet
                  </p>
                  <p className="fw-light" style={{ color: colors.blue1 }}>
                    New post will show up here
                  </p>
                </div>
              )}
            </CRow>

            <div className="d-flex justify-content-end mt-3">
              {/* PAGINATION */}
              {data?.length > 0 && (
                <Pagination
                  currentPage={currentPage}
                  pageCount={pageSize}
                  language={language}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Items;
